import React from "react"
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import BarChartIcon from "@mui/icons-material/BarChart"
import ScheduleIcon from "@mui/icons-material/Schedule"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import {
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    SelectColumnsButton,
    ExportButton,
    TextField,
    DateField,
    usePermissions,
} from "react-admin"
import { Box } from "@mui/material"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"

const ListActions = () => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box mb={1}>
                <RecordActionsTabs subTabs={subTabs} resourceParent="devices"/>
            </Box>
            <Box display="flex" justifyContent="flex-end">
                <TopToolbar>
                    <SelectColumnsButton />
                    <ExportButton />
                </TopToolbar>
            </Box>
        </Box>
    )
}

const Data = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    return (
        <List
            resource={`devices/${id}/data/current+session`}
            //filterDefaultValues={{ role: "Device" }}
            sort={{ field: "value_date", order: "DESC" }}
            title={translate('resources.devicesddt.journal')}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                    "& .RaDatagrid-headerCell": { 
                        fontWeight: 'bold' 
                    }
                }} 
                bulkActionButtons={false} 
            >
                <TextField source="val_p" label={translate("resources.params.fields.p")} />
                <TextField source="val_t" label={translate("resources.params.fields.t")} />
                <TextField source="powerstate" label={translate("resources.params.fields.powerstate")} />
                <TextField source="rssi" label={translate("resources.params.fields.rssi")} />
                <DateField showTime source="value_date" label={translate("resources.params.fields.value_date")}></DateField>
            </DatagridConfigurable>
        </List>
    )
}

export default Data